import React, { Fragment, useEffect } from "react";
import { Card, CardTitle, Button, Table, Form } from "reactstrap";
import CustomTableHeader from "../../common/CustomTableHeader";
import CustomTableLoader from "../../common/CustomTableLoader";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import CustomEditButton from "../../common/CustomEditButton";
import CustomDeleteButton from "../../common/CustomDeleteButton";
import { useState } from "react";
import {
  DOCUMENT_VARIABLE_LIST_URL,
  DOCUMENT_VARIABLE_DELETE_URL,
} from "../../../utils/APIEndpoints";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import {
  getAlertToast,
  getConfirm,
} from "../../../utils/functions/CustomFunctions";
import CreateVariableDialog from "./CreateVariableDialog";
import {
  GOTO_SELECTED_STEP,
  SET_VARIABLES_LIST,
} from "../../../redux/actions/ActionTypes";
import { useDispatch, useSelector } from "react-redux";

//Table Columns
const tableColumns = [
  { title: "Label" },
  { title: "Fee ($)" },
  { title: "Actions" },
];

const initialFormData = {
  labelName: "",
  price: "",
  feeVariableTypeId: "",
  formula: "[]",
  isNonDisplayVariable: false,
  addToagencyfee: true,
  //multichoiceDetails: [],
};

export default function VariablesList(props) {
  const { agencyServiceId = "", documentsList = [] } = props;
  const { currentStep, step1 = {} } = useSelector(
    (state) => state.CreateDocumentForm
  );

  const { formInitialValues = {} } = step1;
  const { documentType = "" } = formInitialValues;
  const one = useSelector((state) => state.HandleDocumentFormat);
  const { documentsType = "" } = one;
  const two = useSelector((state) => state.HandleDocumentType);
  const { paymentsType = "" } = two;
  const dispatch = useDispatch();
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [createModal, setCreateModal] = useState();
  const [isAdd, setIsAdd] = useState(false);

  const createToggle = () => setCreateModal(!createModal);

  const createRecord = async () => {
    setFormData(initialFormData);
    setIsAdd(true);
    setCreateModal(true);
  };
  console.log("I am call variableList");

  //Variable List
  const getVariableList = async () => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: DOCUMENT_VARIABLE_LIST_URL,
        headers: authHeader(),
        params: {
          agencyServiceId,
        },
      };
      const response = await API(options);
      const { status, feeDetails = [] } = response.data;

      if (status === "Success") {
        setGridData(feeDetails);
        dispatch({
          type: SET_VARIABLES_LIST,
          payload: feeDetails,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  // console.log('gridData ', gridData, formData);
  //Edit Record
  const editRecord = async (event) => {
    const {
      fees_id,
      label,
      price,
      fee_type_id,
      formula,
      non_display_variable,
      multi_choice_details,
    } = event.currentTarget.dataset;

    const dataToForm = {
      labelName: label,
      price: price,
      feesId: fees_id,
      feeVariableTypeId: fee_type_id,
      formula: formula,
      isNonDisplayVariable: non_display_variable === "true" ? true : false,
      multichoiceDetails: multi_choice_details,
    };
    setIsAdd(false);
    setFormData(dataToForm);
    setCreateModal(true);
  };

  //Delete Record
  const deleteRecordConfirm = async (event) => {
    const { fees_id } = event.currentTarget.dataset;
    Swal.fire(
      getConfirm("warning", "Are you sure do you want to delete?")
    ).then((result) => {
      if (result.value) {
        deleteRecord(fees_id);
      }
    });
  };

  const deleteRecord = async (fees_id) => {
    try {
      setLoading(true);
      const options = {
        method: "DELETE",
        url: DOCUMENT_VARIABLE_DELETE_URL,
        headers: authHeader(),
        params: { feesId: fees_id },
      };
      const response = await API(options);
      const { status } = response.data;
      if (status === "Success") {
        getVariableList();
        Swal.fire(getAlertToast("success", "Record removed successfully"));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const saveCallBack = () => {
    getVariableList();
    createToggle(false);
  };

  //Validate If Variables Added
  //Submit Form
  const validateIsVariablesAdded = async (event) => {
    event.preventDefault();
    if (gridData.length) {
      dispatch({
        type: GOTO_SELECTED_STEP,
        payload: 3,
      });
    } else {
      Swal.fire(getAlertToast("error", "Please add variable"));
    }
  };

  //Did Mount
  useEffect(() => {
    if (agencyServiceId) {
      getVariableList();
    }
  }, [agencyServiceId]);
  console.log(formData);
  return (
    <Fragment>
      <Card body className="mt-5">
        <div className="tableTitleBg mb-4">
          <CardTitle className=" " style={{ margin: "0" }}>
            Variables{" "}
          </CardTitle>
          <Button className="f-r" color="primary" onClick={createRecord}>
            <i className="fas fa-plus"></i> New Variable
          </Button>
        </div>
        <Form form="true" onSubmit={validateIsVariablesAdded} id="form_step_2">
          <Table responsive hover>
            {/* Table Header */}
            <CustomTableHeader tableColumns={tableColumns} />
            {/* Table Header */}
            <tbody>
              {loading ? (
                // Table Loader
                <CustomTableLoader columnsCount={tableColumns.length} />
              ) : (
                // Table Loader
                <Fragment>
                  {!gridData.length ? (
                    //  Empty Record
                    <CustomTableEmptyRecord
                      columnsCount={tableColumns.length}
                    />
                  ) : (
                    //  Empty Record
                    <Fragment>
                      {gridData.map((record, key) => (
                        <tr key={`record_key_${key}`}>
                          <td>{record.labelName}</td>
                          <td>{parseFloat(record.price).toFixed(2)}</td>
                          <td style={{ width: "200px" }}>
                            {/* Custom Edit Button  */}
                            <CustomEditButton
                              keyvalue={key}
                              data-fees_id={record.feesId}
                              data-fee_type_id={record.feeVariableTypeId}
                              data-label={record.labelName}
                              data-price={record.price}
                              data-formula={record.formula}
                              data-non_display_variable={
                                record.isNonDisplayVariable
                              }
                              data-multi_choice_details={
                                record.multichoiceDetails
                              }
                              onClick={editRecord}
                            />
                            {/* Custom Edit Button  */}

                            {/* Custom Remove Button  */}
                            <CustomDeleteButton
                              keyvalue={key}
                              data-fees_id={record.feesId}
                              onClick={deleteRecordConfirm}
                            />
                            {/* Custom Remove Button  */}
                          </td>
                        </tr>
                      ))}
                    </Fragment>
                  )}
                </Fragment>
              )}
            </tbody>
          </Table>
        </Form>
      </Card>
      {/* create Modal */}
      {createModal && (
        <CreateVariableDialog
          modal={createModal}
          toggle={createToggle}
          formData={formData}
          documentType={documentType}
          isAdd={isAdd}
          saveCallBack={saveCallBack}
          agencyServiceId={agencyServiceId}
          documentsList={documentsList}
        />
      )}
      {/* end create Modal */}
    </Fragment>
  );
}
